import React from "react";
import { Modal, Box, Grid } from "@mui/material";
import { IoCloseCircleOutline } from "react-icons/io5";

const CustomModal = ({
  open,
  setOpen,
  modalContent,
  width,
  modalTitle,
  transparent,
  height,
  scrollable,
  closebtn
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "30%",
    height: height ? height : "auto",
    overflowY: scrollable ? "scroll" : "hidden",
    border: false,
    boxShadow: 24,
    borderRadius: "0.5em",
  };

  return (
    <Modal
      open={open}
      onClose={() => {closebtn != "remove" ? setOpen(false): ""}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      slotProps={{
        backdrop: { style: { backgroundColor: "rgba(0, 0, 0, 0.6)" } },
      }}
    >
      <Box sx={style} className="ModalBG">
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          lg={12}
          xs={12}
          md={12}
          className="GradiantButton rounded-top "
        >
          <Grid
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            className="p-3  rounded-top"
          >
            {modalTitle}
            {
              closebtn != "remove" ? 
                <IoCloseCircleOutline
                  onClick={() => setOpen(false)}
                  style={{ cursor: "pointer", color: "#FFF" }}
                  size={30}
                  className="mx-2"
                />
                :""
            }
            
          </Grid>
        </Grid>
        <Grid className={transparent ? "" : "p-3"}>{modalContent}</Grid>
      </Box>
    </Modal>
  );
};

export default CustomModal;
